import Preview from '@components/tech-due-diligence/sections/preview';
import { HERO_FORM_ID, techDueDiligenceState } from '@components/tech-due-diligence/tech-due-diligence.state';
import FinancialDDMisses from '@components/tech-due-diligence/sections/financial-dd-misses';
import Audience from '@components/tech-due-diligence/sections/audience';
import Checklist from '@components/tech-due-diligence/sections/checklist';
import CtaBanner from '@components/tech-due-diligence/sections/cta-banner';
import ProjectsShowcase from '@components/tech-due-diligence/sections/projects-showcase';
import TrustedBy from './sections/trusted-by';

const TechDueDiligenceComponent = () => {
  return (
    <>
      <Preview formId={HERO_FORM_ID} lastElementTitle="Tech Due Diligence" />
      <TrustedBy />
      <FinancialDDMisses />
      <Audience {...techDueDiligenceState.audience} isDifferentColor={false} />
      <Checklist />
      <CtaBanner />
      <ProjectsShowcase />
    </>
  );
};

export default TechDueDiligenceComponent;
